import { Box, IconButton, ListItemText, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useGetMenuMaster } from '~/api/menu';
import AdminProfileIcon from '~/assets/images/adminprofile.svg';
import LogoutIcon from '~/assets/images/logout.svg';
import useAuth from '~/hooks/useAuth';
import PermCheck from '~/utils/PermCheck';
import { RolePolicy } from '~/utils/roles';

const LogoutIconComponent = () => {
  const theme = useTheme();
  return (
    <img
      src={LogoutIcon}
      alt="logout"
      style={{
        filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
      }}
    />
  );
};

const AdminProfileIconComponent = () => {
  const theme = useTheme();
  return (
    <img
      src={AdminProfileIcon}
      alt="logout"
      style={{
        filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
      }}
    />
  );
};

const NavUser = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const { logout, user } = useAuth();
  const handleLogout = async () => {
    try {
      await logout();
      navigate(`/login`, {
        state: {
          from: '',
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box
      sx={{
        p: 1.25,
        pl: drawerOpen ? 3.25 : 2, // alight with nav icons or center optically
        borderTop: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {drawerOpen ? (
        <>
          <PermCheck permissions={RolePolicy.AdminProfilePage}>
            <Tooltip title="Admin Profile">
              <IconButton onClick={() => navigate('/dashboard/admin/profile/details')}>
                <AdminProfileIconComponent />
              </IconButton>
            </Tooltip>
          </PermCheck>

          <ListItemText
            primary={`${user?.firstName} ${user?.lastName}`}
            primaryTypographyProps={{
              variant: 'h6',
              sx: {
                fontWeight: 600,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
            }}
          />
        </>
      ) : null}

      <Tooltip title="Logout" placement="top" arrow>
        <IconButton
          onClick={handleLogout}
          sx={{
            borderRadius: 1.5,
            width: 36,
            height: 36,
            '&:hover': {
              bgcolor: theme.palette.navigation.background,
            },
          }}
        >
          <LogoutIconComponent />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default NavUser;
